// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2NRt4","info":"PatientInfo_info__1aXjR"};